import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html, nothing, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import type { ConsentStore } from '@mfe-4cs/state/ConsentStore';
import comsStore from '@mfe-4cs/state/ComsStore';
import { localDate, localTime, replaceElements } from '@mfe-4cs/components/templates/util';

export function consentTemplate(this: TefComs4csMicroFrontend, consent: ConsentStore): TemplateResult {
  const featureTemplate = this.getTemplateFn('featureTemplate');

  function getPosition() {
    if (consent.client && consent.date) return 'start';
    return consent.features.length ? 'start' : 'center';
  }

  const textColor = consent.deprecated ? 'disabled' : undefined;
  const background = consent.deprecated ? '#eee' : 'none';

  return html`
    ${consent.hintBefore ? html`
      <one-text as="div">${unsafeHTML(consent.hintBefore)}</one-text>` : nothing}
      <one-paper padding="sm" text-color="make-links-blau" background-color="${background}">
        ${consent.modeconstraint === 'edit' ? html`<small>Diese Einwilligung ist aus der Zusammenführung der vorhergehenden Einwilligungen entstanden</small>` : nothing}
        <one-cluster gap="xs" no-wrap y="${getPosition()}" >
          <tef-coms-tri-state-button
            data-test-id="${consent.id}"
            .consent=${consent}
            .checked=${consent.granted}>
          </tef-coms-tri-state-button>

          <one-stack gap="sm">
            <one-text as="p" color="${ifDefined(textColor)}">
              ${unsafeHTML(replaceElements.bind(this)(consent.scope, consent.deprecated))}
              ${comsStore.config?.showVersions ? html`<small>(Vers. ${consent.version})</small>` : nothing}
            </one-text>
            ${consent.features.length ? html`
              <one-stack gap="xs">
                ${consent.features.map((f) => html`${featureTemplate(f, !!consent.deprecated)}`)}
              </one-stack>
            ` : nothing}
            ${consent.client && consent.date ? html`
              <one-list-item size="xs">
                <one-icon name="clock" variant="outline" slot="icon"></one-icon>
                <one-link size="xs"
                  role="button"
                  @click=${() => { /* eslint-disable @typescript-eslint/indent */
                    comsStore.history!.configId = consent.configId;
                    comsStore.history!.consentShortScope = consent.shortScope;
                  } /* eslint-enable @typescript-eslint/indent */}
                >
                  Letzte Änderung am
                  ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.clientDisplay ?? consent.client}
                </one-link>&nbsp;
              </one-list-item>
            ` : nothing}
          </one-stack>
        </one-cluster>
      </one-paper>

      ${consent.hintAfter ? html`
        <one-text as="div">${unsafeHTML(consent.hintAfter)}</one-text>` : nothing}
    `;
}
